import { css } from "@emotion/react";
import "@esri/calcite-components/dist/calcite/calcite.css";
import tw from "twin.macro";

const customGlobalStyles = css`
  html {
    ${tw`h-full bg-gray-200`}
  }

  #webpack-dev-server-client-overlay {
    ${tw`hidden`}
  }
  .nav-link {
    ${tw`py-3 pl-4 pr-2 border-l-4 text-lg border-transparent`}
  }

  .tabulator .tabulator-footer {
    ${tw`font-semibold`}
  }

  .tabulator {
    ${tw`bg-white rounded-md`}
  }
  .tabulator-row {
    ${tw`border-none w-max`}
    overflow: scroll !important;
  }

  /* Force every Tabulator-internal container to not clip */
  .tabulator,
  .tabulator-table {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }

  .tabulator-tableholder {
    overflow-x: scroll !important;
    overflow-y: visible !important;
  }

  /* Pin header to top of the table's scroll context (the page) */
  .tabulator .tabulator-header {
    position: sticky !important;
    top: 65px;
    z-index: 100;
    background: white;
    overflow: scroll !important;
    overflow-x: hidden !important;
  }

  /* Per-table override: add class tabulator-top-0 to the specific table wrapper */
  .tabulator.tabulator-top-0 .tabulator-header {
    top: 0 !important;
  }

  #urgent:hover {
    background-color: #f87171 !important;
    cursor: pointer;
  }
  #question:hover {
    background-color: #8eb3de !important;
    cursor: pointer;
  }
  .tabulator .tabulator-header {
    ${tw`border-none`}
  }
  .tabulator .tabulator-header .tabulator-col {
    ${tw`bg-gray-200 border-r border-b border-gray-300`}
  }
  .tabulator-col-title {
    ${tw`font-semibold tracking-wide`}
  }
  .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
    ${tw`font-semibold`}
  }
  .tabulator-cell {
    ${tw`border-b border-r border-gray-300 py-10 px-8`}
  }
  .tabulator-tableholder {
    ${tw`whitespace-nowrap overflow-x-auto w-full min-h-full`}
  }

  .tabulator-tableholder .tabulator-placeholder {
    ${tw`translate-x-2 p-2 translate-y-1 text-lg font-semibold`}
  }

  .tabulator .tabulator-footer .tabulator-page.active {
    ${tw`text-blue-600`}
  }

  #trashIcon svg {
    ${tw`fill-red-600`}
  }

  .tabulator .tabulator-footer {
    ${tw`border-none px-1 pt-4 pb-0`}
  }

  #record-count {
    ${tw`ml-0.5 float-left`}
  }

  .nav-link {
    ${tw`flex items-center justify-between`}
  }
  .nav-link:hover {
    ${tw`border-gray-200`}
  }
  .nav-link .pending {
    ${tw`border-transparent`}
  }
  .nav-link.active {
    ${tw`bg-blue-100 border-blue-600 font-semibold`}
  }

  input[type="search"]::-webkit-search-cancel-button {
    display: none !important;
  }

  body {
    ${tw`h-full`}
    --calcite-ui-brand: #1A67B2;
    --calcite-modal-scrim-background: rgba(0, 0, 0, 0.25);
    --calcite-ui-text-2: #272626;
  }

  h1 {
    ${tw`text-3xl font-bold`}
  }

  h2 {
    ${tw`text-2xl font-bold`}
  }

  h3 {
    ${tw`text-lg font-semibold`}
  }

  h4 {
    ${tw`text-base font-medium`}
  }
  calcite-navigation calcite-menu calcite-menu-item {
    ${tw`font-semibold`}
  }
`;

export default customGlobalStyles;
